<template>
    <div class="error-view">
        <FontAwesomeIcon
            v-if="icon"
            class="error-view-icon"
            :icon="['fas', icon]"
        />

        <h2
            v-if="title"
            class="error-view-title"
        >
            {{ title }}
        </h2>

        <h3
            v-if="subtitle"
            class="error-view-subtitle"
        >
            {{ subtitle }}
        </h3>

        <hr class="error-view-divider">

        <div
            v-if="$slots.default"
            class="error-view-description"
        >
            <!-- Description of the error -->
            <slot />
        </div>

        <div class="error-view-actions">
            <!-- Action buttons or links to be shown below the error message -->
            <slot name="actions">
                <!-- `<Button variant="primary">Contact Administrator</Button>` <br> `<Button href="https://imtins.com">IMT Website</Button>` -->
                <Button variant="primary">
                    Contact Administrator
                </Button>

                <Button href="https://imtins.com">
                    IMT Website
                </Button>
            </slot>
        </div>
    </div>
</template>

<script>
    import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

    import Button from './Button.vue';

    export default {
        name: 'Error',
        components: {
            Button,
            FontAwesomeIcon,
        },
        props: {
            /**
             * Icon to be shown at the top of the error view
             */
            icon: {
                // `undefined`
                default: undefined,
                required: false,
                type: [Array, String, undefined],
            },
            /**
             * Subtitle text to be shown below the title
             */
            subtitle: {
                // `undefined`
                default: undefined,
                required: false,
                type: [String, undefined],
            },
            /**
             * Title text to be shown at the top of the error view
             */
            title: {
                // `undefined`
                default: undefined,
                required: false,
                type: [String, undefined],
            },
        },
    };
</script>
